<template>
    <RadioGroup v-model="selected" class="mt-2">
        <RadioGroupLabel class="sr-only"> Choose an option</RadioGroupLabel>
        <div class="grid grid-cols-3 gap-3 sm:grid-cols-4">
            <RadioGroupOption
                v-for="(value, label) in options" :key="value" v-slot="{ active, checked }" as="template"
                :value="value">
                <div
                    :class="['cursor-pointer focus:outline-none', active ? '' : '', checked ? 'border-zinc-700 bg-neutral-50' : 'bg-neutral-50 border-gray-200 text-gray-900 hover:bg-gray-50', 'border rounded-md py-3 px-3 flex items-center justify-center text-sm font-medium  sm:flex-1']">
                    <RadioGroupLabel as="span">{{ label }}</RadioGroupLabel>
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>

<script>
import {RadioGroup, RadioGroupLabel, RadioGroupOption} from '@headlessui/vue';
import {defineComponent} from 'vue';

export default {
    components: {
        RadioGroup,
        RadioGroupLabel,
        RadioGroupOption,
    },
    props: {
        options: {
            required: true,
            type: Array,
        }
    },
    emits: ['updateForm'],

    data() {
        return {
            selected: null,
        };
    },

    watch: {
        selected(val) {
            this.$emit('updateForm', {field: 'type', value: val});
        }
    }
};
</script>
